import AppliedFilterPillView from './applied_filter_pill_view';
import AppliedFilterListPillView from './applied_filter_list_pill_view';

export default Backbone.View.extend({
  excludes: [
    'morning_availability',
    'midday_availability',
    'evening_availability',
    'fulltime_availability',
  ],
  events: {
    'click .js-search-toggle-filters': 'toggleAdvancedFilters',
  },

  initialize(options) {
    const self = this;
    this.query = options.query;
    this.$container = $('.js-advanced-filters-view');
    this.$toggle = this.$('.js-search-toggle-filters');
    if (this.$toggle.hasClass('visible')) {
      this.model.set('visible', true);
    }
    this.model.on('change:visible', _.bind(this.onModelChangedVisible, this));

    // Create all of the applied filter pills
    this.pillViews = [];
    _.each(this.$('.js-search-applied-filter-pill'), el => {
      // This is a hack to hide the top-level advanced filters that are
      // defined in the excludes array
      const fieldName = $(el).attr('data-field-name');
      if (_.contains(self.excludes, fieldName)) {
        return;
      }
      const view = new AppliedFilterPillView({
        el: $(el),
        model: self.query,
        fieldName,
      });
      self.pillViews.push(view);
    });
    _.each(this.$('.js-search-applied-filter-list-pill'), el => {
      const view = new AppliedFilterListPillView({
        el: $(el),
        model: self.query,
        fieldName: $(el).attr('data-field-name'),
        value: parseInt($(el).attr('data-value')),
      });
      self.pillViews.push(view);
    });
  },

  hasFiltersApplied() {
    return this.$('.js-search-applied-filter-pill:visible').length > 0;
  },

  onModelChangedVisible() {
    if (this.model.get('visible')) {
      this.showAdvancedFilters();
    } else {
      this.hideAdvancedFilters();
    }
  },

  showAdvancedFilters() {
    this.$container.removeClass('hidden');
  },

  hideAdvancedFilters() {
    this.$container.addClass('hidden');
  },

  toggleAdvancedFilters(event) {
    let visible = this.model.get('visible'),
      newText = '';

    event.preventDefault();

    // If we're fixed, the just scroll to the top
    if (this.$el.css('position') === 'fixed') {
      Rover.pubSub.trigger('scroll', 0);
      if (!visible) {
        this.model.set('visible', true);
      }
    } else {
      this.model.set('visible', !visible);
    }

    visible = this.model.get('visible');

    if (visible) {
      newText = this.$toggle.attr('data-less-text');
      this.$toggle.addClass('visible');
    } else {
      newText = this.$toggle.attr('data-more-text');
      this.$toggle.removeClass('visible');
    }

    if (newText) {
      this.$toggle.find('.js-toggle-text').text(newText);
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/advanced_filters_bar_view.js